import initialState from '../../data/location';
import ActionTypes from '../constants/action-types';

const LocationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_LOCATION:
            return {
                ...state,
                code: action.payload
            };

        case ActionTypes.RESET_LOCATION:
            return {
                ...state,
                code: null
            };

        default: return state;
    }
}

export default LocationReducer;
